export default __webpack_public_path__ + "static/media/sweet-1.4d2d961c.jpeg";